import { FlowBuilder } from "../../../FlowBuilder";
import { FlowConfiguration } from "../../../../rule-engine-core/Flow/FlowConfiguration";
import { RunStatementRule } from "../../../../rule-engine-core/Flow/Steps/Rules/RunStatementRule";
import { StringDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { FlowStepSequence } from "../../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FormStep } from "../../../../rule-engine-core/Flow/Steps/UI/FormStep";
import { RuleStepStrategy } from "../../../../rule-engine-core/Flow/Steps/Rules/BaseFlowRuleStep";
import { BooleanDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { RunValueTable } from "../../../../rule-engine-core/Flow/Steps/Rules/RunValueTable";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const FlowBuilderRuleStepsStories = [
    new StoryNode(
        () => {
            let flow = new FlowConfiguration();
            let primarySequence = flow.allSequences[0];

            primarySequence.addStep(new RunValueTable());

            let runStatement = new RunStatementRule();
            let skill = new StringDataDefinition();
            skill.validValues = ["JavaScript", "Python", "C", "C++", "Java"];
            runStatement.executable.executionResult = skill;
            runStatement.outcomeStrategy = RuleStepStrategy.Paths;
            primarySequence.addStep(runStatement);

            let secondSequence = new FlowStepSequence();
            flow.addSequence(secondSequence);
            secondSequence.desiredX = 100;
            secondSequence.desiredY = 20;

            // C++
            runStatement.getOutcomeInstructions()[3].connectedSequenceId = secondSequence._id;

            runStatement = new RunStatementRule();
            let fullTime = new BooleanDataDefinition("fullTime");
            runStatement.executable.executionResult = fullTime;
            runStatement.outcomeStrategy = RuleStepStrategy.Paths;
            secondSequence.addStep(runStatement);

            let thirdSeq = new FlowStepSequence();
            flow.addSequence(thirdSeq);
            thirdSeq.desiredX = 200;
            thirdSeq.desiredY = 20;

            runStatement.getOutcomeInstructions()[1].connectedSequenceId = thirdSeq._id;

            runStatement = new RunStatementRule();

            let isMale = new BooleanDataDefinition("isMale");
            runStatement.executable.executionResult = isMale;
            runStatement.outcomeName = "isMale";
            thirdSeq.addStep(runStatement);

            thirdSeq.addStep(new FormStep());

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Designer",
        "Rule Steps",
        "Default",
    ),
];
